<script>
import General from '../../../../resources/frontend/js/mixins/general.vue';
import Page from '../../../../resources/frontend/js/mixins/page.vue';

export default {
    mixins: [General, Page],

    props: {
        content: {
            type: Object,
            default: () => {},
            required: true,
        },

        step: {
            type: String,
            default: '',
            required: false,
        },
    },
};
</script>
